<template>
  <el-carousel class="dashboard-indicator-carousel" height="160px" type="card" :autoplay="false">
    <el-carousel-item v-for="item in dashboards_" :key="item.id">
      <el-card>
        <div class="flex-col flex__center">
          <div class="flex-row flex-row-space-between style-fullWidth">
            <dashboard-indicator-template
              :indicator1="item.countOfIncomingDoc"
              :indicator2="item.countOfUnreadIncomingDoc"
              title="Văn bản đến"
              @click="viewListIncomingDocProcessing(item)"
            ></dashboard-indicator-template>

            <dashboard-indicator-template
              :indicator1="item.countOfOutGoingDoc"
              :indicator2="item.countOfUnreadOutGoingDoc"
              title="Văn bản dự thảo"
              @click="viewListOutgoingDocProcessing(item)"
            ></dashboard-indicator-template>

            <dashboard-indicator-template
              :indicator1="item.countOfUnreadBanHanhOutGoingDoc"
              title="Đã phát hành"
              @click="viewListBanHanhOutgoingDocProcessing(item)"
            ></dashboard-indicator-template>
          </div>
          <span class="margin-top-15 font-weight__bold color__silver">
            <i class="fas fa-user"></i>
            {{ `${item.userDeptRoleViewLabel}` }}
          </span>
        </div>
      </el-card>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import h from "../../services/h";
import constants from "../../constants";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import DashboardIndicatorTemplate from "./dashboard-indicator-template";
import { EventBus } from "../../event-bus";

export default {
  name: "dashboard-indicators",
  components: { DashboardIndicatorTemplate },
  props: ["dashboards"],
  data() {
    return {
      dashboards_: null,
      userDeptRoles: []
    };
  },

  watch: {
    dashboards() {
      this.initComponent();
    }
  },

  async created() {
    await this.loadUserDeptRoles();
    this.initComponent();
  },

  methods: {
    viewListIncomingDocProcessing(item) {
      console.log(JSON.stringify(item));

      let userDeptRole = item.userDeptRole;
      this.$store.commit("changeUserDeptRole", userDeptRole.id);
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: userDeptRole.id
      });

      userDeptRole &&
        this.$router.push({
          name: "vbDenChoXuLy",
          params: {
            userDeptRoleId: userDeptRole.id,
            dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY
          }
        });
    },

    viewListOutgoingDocProcessing(item) {
      let userDeptRole = item.userDeptRole;
      this.$store.commit("changeUserDeptRole", userDeptRole.id);
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: userDeptRole.id
      });

      userDeptRole &&
        this.$router.push({
          name: "vbDuThaoNew",
          params: { userDeptRoleId: userDeptRole.id }
        });
    },

    viewListBanHanhOutgoingDocProcessing(item) {
      let userDeptRole = item.userDeptRole;
      this.$store.commit("changeUserDeptRole", userDeptRole.id);
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: userDeptRole.id
      });

      userDeptRole &&
        this.$router.push({
          name: "vbDaPhatHanhNew",
          params: { userDeptRoleId: userDeptRole.id }
        });
    },

    loadUserDeptRoles() {
      return userDeptRoleViewService
        .findAllByCurrentUser()
        .then(response => (this.userDeptRoles = response.data));
    },

    initComponent() {
      this.dashboards_ = h.collect(
        h.findAll(this.dashboards, item => this.isVisible(item)),
        item => {
          let userDeptRole = this.findUserDeptRole(item);
          return {
            userDeptRoleViewLabel: `${userDeptRole.positionName} ${userDeptRole.deptName}`,
            countOfIncomingDoc: item.countOfIncomingDoc,
            countOfUnreadIncomingDoc: item.countOfUnreadIncomingDoc,
            countOfOutGoingDoc: item.countOfOutGoingDoc,
            countOfUnreadOutGoingDoc: item.countOfUnreadOutGoingDoc,
            countOfUnreadBanHanhOutGoingDoc:
              item.countOfUnreadBanHanhOutGoingDoc,
            userDeptRole: item.userDeptRole
          };
        }
      );
    },

    findUserDeptRole(item) {
      return h.find(
        this.userDeptRoles,
        userDeptRole => userDeptRole.id === item.userDeptRole.id
      );
    },

    isVisible(item) {
      let userDeptRoleView = this.findUserDeptRole(item);
      return (
        userDeptRoleView &&
        [constants.ROLE.CODE.CHUYEN_VIEN, constants.ROLE.CODE.LANH_DAO].indexOf(
          userDeptRoleView.roleCode
        ) !== -1
      );
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/dashboard/dashboard-indicators.vue